export default __webpack_public_path__ + "static/media/Band of the Immortals.d2c2d4f3.jpg";